<template>
  <div>
    <van-popup v-model="showPopup" :close-on-click-overlay="false">
      <div class="login-popup">
        <div class="title">
          当前账号异地登录，请重新登录！
        </div>
        <div class="choice_part">
            <ul>
                <li 
                :class="[active == index ?'active':'']"
                v-for="(item,index) in dataArr" :key="index"
                @click="choice(index)"
                >{{item}}</li>
            </ul>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getStore,removeStore } from "assets/commonjs/storage";
export default {
    data(){
        return{
            dataArr:['取消','重新登录'],
            active:1
        }
    },
  props: ["showPopup"],
  methods:{
      choice(index){
         this.active = index
         removeStore("userInfoAll")
         if(index == 0){
             this.$router.push('/questionAnswer')
         }else{
             if (
                getStore("noneheader") == null ||
                getStore("noneheader") == "" ||
                getStore("noneheader") == undefined
            ){
                this.$router.push('/login')
            }else{
               window.location.href = "intercept_login" 
            }
         }
      }
  }
};
</script>


<style lang="scss" scoped>
@import "~assets/styles/mixin";
.login-popup{
    border-radius: .1rem;
    background: #fff;
    text-align: center;
    width: 6rem;
    margin: 0 auto;
    .title{
        padding:.7rem .65rem;
        @include sc(.32rem,#333)
    }
    .choice_part{
        border-top:.025rem solid #ddd;
        ul{
            display: flex;
            justify-content: center;
            padding:.12rem 0;
            li{
                border-right: .025rem solid #ddd;
                @include sc(.3rem,#666);
                line-height: .8rem;
                padding-right: .8rem;
            }
            li.active{
                color: #0A95FF
            }
            li:last-child{
                border-right: none;
                padding-left: .8rem;
                padding-right: 0;
            }
        }
    }
}
.van-popup{
    background:none
}
</style>